// extracted by mini-css-extract-plugin
export default {"props_container":"ingredient-details_props_container__KlqAj"};